import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useStateMachine } from 'little-state-machine'

/**
 * 제안하기 type 단계 — 통합 찾기로 이전되어 더 이상 UI 없음.
 * 직접 접근 시: offerInput에 필수값이 있으면 terms/confirm으로, 없으면 /search로 리다이렉트.
 */
const OfferDefaultPage = () => {
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const { state } = useStateMachine()
	const userType = searchParams.get('by') || 'pro'
	const offerInput = state?.offerInput

	useEffect(() => {
		const hasTarget = !!offerInput?.targetUserId
		const hasOfferType = !!offerInput?.offerType
		const isPreContract = offerInput?.offerType === 'preContract'
		const hasTours =
			offerInput?.tourIds?.length > 0 &&
			(offerInput?.offerType === 'short'
				? offerInput.tourIds.length >= 1
				: offerInput?.offerType === 'long'
					? offerInput.tourIds.length >= 2
					: offerInput?.offerType === 'period'
						? true
						: false)

		if (hasTarget && hasOfferType) {
			if (isPreContract) {
				navigate(`/offer/create/confirm?by=${userType}`, { replace: true })
				return
			}
			if (hasTours || offerInput?.offerType === 'period') {
				navigate(`/offer/create/terms?by=${userType}`, { replace: true })
				return
			}
		}
		navigate('/search', { replace: true })
	}, [navigate, userType, offerInput?.targetUserId, offerInput?.offerType, offerInput?.tourIds])

	return null
}

export default OfferDefaultPage
